export default "__VITE_ASSET__D3hTu7Tj__"